import { render, staticRenderFns } from "./OrganizationCharts.vue?vue&type=template&id=68e1360f&scoped=true"
import script from "./OrganizationCharts.vue?vue&type=script&lang=js"
export * from "./OrganizationCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e1360f",
  null
  
)

export default component.exports